import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { epicContractInfoFactory } from "./epicContractInfoFactory";
export var epicContractInfoPlayerLevelUp = epicContractInfoFactory(TypeActionPlayerInfo.AddLevel);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractInfoPlayerLevelUp.ts
// module id = 1993
// module chunks = 3